import * as apiroutes from '../apiRoutes'

class FileServices {
    static async getCategoryImage(id, cacheBuster = null) {
        try {
            if (id) {
                let url = `${apiroutes.CATEGORIES}/${id}/logo`;
                if (cacheBuster) {
                    url += `?t=${encodeURIComponent(cacheBuster)}`;
                }
                const response = await fetch(url, { credentials: 'include' });
                if (!response.ok) {
                    throw new Error('Failed to fetch image');
                }
                return window.URL.createObjectURL(await response.blob());
            } else {
                return '/assets/siteLogo/logo.png';
            }
        } catch (error) {
            return '/assets/images/no-header-img.jpg';
        }
    }

    static async getSubCategoryImage(id, cacheBuster = null) {
        try {
            if (id) {
                let url = `${apiroutes.SUBCATEGORIES}/${id}/logo`;
                if (cacheBuster) {
                    url += `?t=${encodeURIComponent(cacheBuster)}`;
                }
                const response = await fetch(url, { credentials: 'include' });
                if (!response.ok) {
                    throw new Error('Failed to fetch image');
                }
                return window.URL.createObjectURL(await response.blob());
            } else {
                return '/assets/siteLogo/logo.png';
            }
        } catch (error) {
            return '/assets/images/no-header-img.jpg';
        }
    }

    

    static async getOrgtImage(logo, orgId,cacheBuster = null) {
        try {
            if (logo && orgId) {
                     let url = `${apiroutes.ORGANIZATIONS}/${orgId}/logo`
                if (cacheBuster) {
                   url +=  `?t=${encodeURIComponent(cacheBuster)}`;
                }
                const response = await fetch(url, {
                    credentials: 'include',
                });
                if (!response.ok) {
                    throw new Error('Failed to fetch image');
                }
                return window.URL.createObjectURL(await response.blob());
            } else {
                return '/assets/siteLogo/logo.png';
            }
        } catch (error) {
            return '/assets/images/no-header-img.jpg';
        }
    }

    static async getSocialMediaImage(id, cacheBuster = null) {
        try {
            if (id) {
                let url = `${apiroutes.SOCIALMEDIASETUPS}/${id}/logo`;
                if (cacheBuster) {
                    url += `?t=${encodeURIComponent(cacheBuster)}`;
                }
                const response = await fetch(url, { credentials: 'include' });
                if (!response.ok) {
                    throw new Error('Failed to fetch image');
                }
                return window.URL.createObjectURL(await response.blob());
            } else {
                return '/assets/siteLogo/logo.png';
            }
        } catch (error) {
            return '/assets/images/no-header-img.jpg';
        }
    }

    static async getSupportTypeImage(id, cacheBuster = null) {
        try {
            if (id) {
                let url = `${apiroutes.SUPPORTSETUPS}/${id}/logo`;
                if (cacheBuster) {
                    url += `?t=${encodeURIComponent(cacheBuster)}`;
                }
                const response = await fetch(url, { credentials: 'include' });
                if (!response.ok) {
                    throw new Error('Failed to fetch image');
                }
                return window.URL.createObjectURL(await response.blob());
            } else {
                return '/assets/siteLogo/logo.png';
            }
        } catch (error) {
            return '/assets/images/no-header-img.jpg';
        }
    }

}

export default FileServices
